export default {
  name: "Referral and Hiring Instructions",
  prefix: "G",
  sections: [
    {
      divider: "hide",
      name: "",
      fields: [
        {
          code: "G.1",
          machine_name: "eta_790a_g1_how_to_apply",
          widget: "text_area",
          label: `
                  <span>Explain <u>how</u> prospective applicants may be considered for employment under this job order, including verifiable contact information for the employer (or the employer’s authorized hiring representative), methods of contact, and the days and hours applicants will be considered for the job opportunity.<br></br><i>(Please begin response on this form and use Addendum C if additional space is needed.)</i></span>`,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Enter a full statement on how perspective applicants may be considered under job order.",
            },
          ],
          tooltip: `Explain how prospective applicants may be considered for employment under this job order, including verifiable contact
          information for the employer (or the employer’s authorized hiring representative) and the methods of contact (e.g., email,
          phone) that prospective U.S. applicants may use to be considered for the job opportunity. Summarize how applicants are
          to be considered, referred, and hired. For example, indicate the days and hours that the employer or the employer’s
          authorized hiring representative will be available to interview workers by telephone and/or in-person and whether anybody
          different from the employer has hiring authority. If additional space is needed, use the Form ETA-790A, Addendum C.`,
          placeholder: "",
          width: 8,
          rows: 10,
          inputLimit: 4000,
          is_required: true,
        },
      ],
    },
    {
      machine_name: "_add_addendum_c_referral_and_hiring_instructions",
      coloring: "blue",
      isModal: true,
      sectionHeader:
        "Material Terms and Conditions - Referral and Hiring Instructions",
      openModalHeader: "Add Addendum C",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      master_fieldArray: "eta_790a_addendum_c",
      listType: "inline",
      modalFields: [
        {
          machine_name: "section_number",
          label:
            "Section/Item Number and Category of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Pay Deductions",
            "Job Requirements",
            "Meal Provision",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Referral and Hiring Instructions",
          ],
          disabled: true,
          initialValue: "Referral and Hiring Instructions",
          validate: ["required"],
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term Condition",
          widget: "text",
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 3500,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
        },
      ],
    },
    {
      name: "Two of three entries required*",
      fields: [
        {
          code: "G.2",
          machine_name: "eta_790a_g2_apply_phone",
          widget: "phone",
          label: "Telephone Number to Apply",
          validate: [
            "phone",
            {
              subsetOfSetRequired: "eta_790a_g2_apply_phone",
              message:
                "Enter at least two (2) verifiable methods by which prospective U.S. workers can contact the employer and apply for the job opportunity.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: [
                  // "eta_790a_g4_apply_url",
                  "eta_790a_g2_apply_phone",
                  // "eta_790a_g3_apply_email"
                  "apply_url",
                  "apply_email",
                ],
              },
            },
          ],
          tooltip: `Enter the area code and business telephone number prospective U.S. applicants may use to call the employer to be
          considered for the job opportunity. If a phone number is not available, leave this field <b>BLANK</b> and the system will insert
          "N/A" at submission of the application.`,
        },
        {
          code: "G.3",
          machine_name: "apply_extensions",
          widget: "text",
          label: "Extension",
          validate: ["number"],
          parse: "positiveWholeNumber",
          maxLength: 4,
          tooltip: `Enter the extension of the telephone number for prospective U.S. applicants to use to call the employer to be considered
          for the job opportunity, if applicable. If there is no extension number, enter “<b>N/A</b>.”`,
        },
        {
          code: "G.4",
          // machine_name: "eta_790a_g3_apply_email",
          machine_name: "apply_email",
          widget: "text",
          validate: [
            {
              email: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
            {
              // subsetOfSetRequired: "eta_790a_g3_apply_email",
              subsetOfSetRequired: "apply_email",
              message: "Two of these three fields must be filled out.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: [
                  // "eta_790a_g4_apply_url",
                  "eta_790a_g2_apply_phone",
                  // "eta_790a_g3_apply_email"
                  "apply_url",
                  "apply_email",
                ],
                allowNAs: false,
              },
            },
          ],
          label: "Email Address to Apply",
          maxLength: 60,
          tooltip: `Enter the business email address prospective U.S. applicants may use to email the employer to be considered for the job
          opportunity in the format name@emailaddress.top-leveldomain. If email is not a method of contact prospective U.S.
          applicants may use to be considered for the job opportunity, enter “<b>N/A</b>.”`,
        },
        {
          code: "G.5",
          // machine_name: "eta_790a_g4_apply_url",
          machine_name: "apply_url",
          widget: "text",
          label: "Website Address (URL) to Apply",
          validate: [
            {
              url: {
                extraData: {
                  allowNAs: true,
                },
              },
            },
            {
              subsetOfSetRequired: "eta_790a_g4_apply_url",
              message: "Two of these three fields must be filled out.",
              needsFieldValues: true,
              extraData: {
                numRequired: 2,
                fieldArray: [
                  // "eta_790a_g4_apply_url",
                  "eta_790a_g2_apply_phone",
                  // "eta_790a_g3_apply_email"
                  "apply_url",
                  "apply_email",
                ],
                allowNAs: false,
              },
            },
          ],
          maxLength: 70,
          tooltip: `Enter the employer’s business website address (URL) in the format <a href="www.employerwebsitename.top-leveldomain" target="_blank">www.employerwebsitename.top-leveldomain</a>. If the
          employer does not have a business website address or its website is not a method of contact prospective U.S. applicants
          may use to be considered for the job opportunity, enter “N/A.” Examples of valid suffixes include:
          <br>
          <br>
          .com - commercial business <br>
          .org - Organizations (nonprofit) <br>
          .edu - Educational institutions <br>
          .net - Network organizations <br>
          .gov - Government agencies <br>
          .mil – Military`,
        },
      ],
    },
  ],
};
